/* ------------------------------------------------------------------
  File: siteConfig.js
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-05-10
------------------------------------------------------------------ */

// Purpose:
//   - siteConfig defines the core identity, brand, contact,
//     location, domain, and social information for the website.
//   - It should be used as the single source of truth for
//     basic company information across the frontend.

export const siteConfig = {
  name: "Accend Holdings Ltd.",
  shortName: "Accend",
  legalName: "Accend Holdings Ltd.",
  domain: "accend-holdings.com",
  url: "https://www.accend-holdings.com",

  tagline: "Building enterprises that shape Africa's future.",

  description:
    "Accend Holdings Ltd. is a multinational holding company investing in technology, engineering, infrastructure, and strategic growth sectors.",

  location: {
    country: "Liberia",
    city: "Monrovia",
  },

  contact: {
    email: "info@accend-holdings.com",
    phone: "+231 XXX XXX XXX",
    address: "Monrovia, Liberia",
  },

  socialLinks: {
    linkedin: "https://www.linkedin.com/company/accendgroup",
    facebook: "https://www.facebook.com/accendgroup",
    x: "https://x.com/accendgroup",
    instagram: "https://www.instagram.com/accendgroup",
  },
};